import axios from "@/axios/axios";

import * as apis from "@/apis";
import * as errors from "@/errors";
import * as successes from "@/successes";

import {dictToParams, getAxiosTokenConfig, sendAction} from "@/helpers";

import {notifyError, notifySuccess} from "@/toast-notifications";


// GET QUESTIONS
export const GET_QUESTIONS_REQUEST = "GET_QUESTIONS_REQUEST";
export const GET_QUESTIONS_SUCCESS = "GET_QUESTIONS_SUCCESS";
export const GET_QUESTIONS_ERROR = "GET_QUESTIONS_ERROR";

export const getQuestions = () => {
    return dispatch => {
        dispatch(sendAction(GET_QUESTIONS_REQUEST));
        axios.get(apis.QUESTIONS_API, getAxiosTokenConfig())
            .then(({data}) => {
                dispatch(sendAction(GET_QUESTIONS_SUCCESS, {data}));
            })
            .catch(error => {
                dispatch(sendAction(GET_QUESTIONS_ERROR, {error}));
                notifyError(errors.GET_QUESTIONS_ERROR);
            });
    };
};

// ADD QUESTION
export const ADD_QUESTION_REQUEST = "ADD_QUESTION_REQUEST";
export const ADD_QUESTION_SUCCESS = "ADD_QUESTION_SUCCESS";
export const ADD_QUESTION_ERROR = "ADD_QUESTION_ERROR";

export const addQuestion = (question) => {
    return dispatch => {
        dispatch(sendAction(ADD_QUESTION_REQUEST));
        axios.post(`${apis.QUESTIONS_API}`, question, getAxiosTokenConfig())
            .then(({data}) => {
                dispatch(sendAction(ADD_QUESTION_SUCCESS, {data}));
                notifySuccess(successes.ADD_QUESTION_SUCCESS);
            })
            .catch(error => {
                dispatch(sendAction(ADD_QUESTION_ERROR, {error}));
                notifyError(errors.ADD_QUESTION_ERROR);
            });
    };
};

// UPDATE QUESTION
export const UPDATE_QUESTION_REQUEST = "UPDATE_QUESTION_REQUEST";
export const UPDATE_QUESTION_SUCCESS = "UPDATE_QUESTION_SUCCESS";
export const UPDATE_QUESTION_ERROR = "UPDATE_QUESTION_ERROR";

export const updateQuestion = (question) => {
    return dispatch => {
        dispatch(sendAction(UPDATE_QUESTION_REQUEST));
        axios.patch(`${apis.QUESTIONS_API}${question.id}/`, question, getAxiosTokenConfig())
            .then(({data}) => {
                dispatch(sendAction(UPDATE_QUESTION_SUCCESS, {data}));
                notifySuccess(successes.UPDATE_QUESTION_SUCCESS);
            })
            .catch(error => {
                dispatch(sendAction(UPDATE_QUESTION_ERROR, {error}));
                notifyError(errors.UPDATE_QUESTION_ERROR);
            });
    }
};

// UPDATE QUESTION
export const SET_QUESTIONS = "SET_QUESTIONS";

export const setQuestions = (questions) => {
    return dispatch => {
        dispatch(sendAction(SET_QUESTIONS, {data: questions}));
    }
};

// DELETE QUESTION
export const DELETE_QUESTION_REQUEST = "DELETE_QUESTION_REQUEST";
export const DELETE_QUESTION_SUCCESS = "DELETE_QUESTION_SUCCESS";
export const DELETE_QUESTION_ERROR = "DELETE_QUESTION_ERROR";

export const deleteQuestion = id => {
    return dispatch => {
        dispatch(sendAction(DELETE_QUESTION_REQUEST));
        axios.delete(`${apis.QUESTIONS_API}${id}/`, getAxiosTokenConfig())
            .then(({data}) => {
                dispatch(sendAction(DELETE_QUESTION_SUCCESS, {data: id}));
                notifySuccess(successes.DELETE_QUESTION_SUCCESS);
            })
            .catch(error => {
                dispatch(sendAction(DELETE_QUESTION_ERROR, {error}));
                notifyError(errors.DELETE_QUESTION_ERROR);
            });
    }
};

// GET QUESTION TYPES
export const GET_QUESTION_TYPES_REQUEST = "GET_QUESTION_TYPES_REQUEST";
export const GET_QUESTION_TYPES_SUCCESS = "GET_QUESTION_TYPES_SUCCESS";
export const GET_QUESTION_TYPES_ERROR = "GET_QUESTION_TYPES_ERROR";

export const getQuestionTypes = () => {
    return dispatch => {
        dispatch(sendAction(GET_QUESTION_TYPES_REQUEST));
        axios.get(apis.QUESTION_TYPES_API, getAxiosTokenConfig())
            .then(({data}) => {
                dispatch(sendAction(GET_QUESTION_TYPES_SUCCESS, {data}));
            })
            .catch(error => {
                dispatch(sendAction(GET_QUESTION_TYPES_ERROR, {error}));
                notifyError(errors.GET_QUESTION_TYPES_ERROR);
            });
    }
};

// GET FEEDBACKS
export const GET_FEEDBACKS_REQUEST = "GET_FEEDBACKS_REQUEST";
export const GET_FEEDBACKS_SUCCESS = "GET_FEEDBACKS_SUCCESS";
export const GET_FEEDBACKS_ERROR = "GET_FEEDBACKS_ERROR";

export const getFeedbacks = (reservation = null) => {
    const params = reservation ? `?reservation=${reservation}`: '';
    return dispatch => {
        dispatch(sendAction(GET_FEEDBACKS_REQUEST));
        axios.get(`${apis.FEEDBACKS_API}${params}`, getAxiosTokenConfig())
            .then(({data}) => {
                dispatch(sendAction(GET_FEEDBACKS_SUCCESS, {data}));
            })
            .catch(error => {
                dispatch(sendAction(GET_FEEDBACKS_ERROR, {error}));
                notifyError(errors.GET_FEEDBACKS_ERROR);
            });
    }
};

// GET BARESTHO FEEDBACKS
export const GET_BARESTHO_FEEDBACKS_REQUEST = "GET_BARESTHO_FEEDBACKS_REQUEST";
export const GET_BARESTHO_FEEDBACKS_SUCCESS = "GET_BARESTHO_FEEDBACKS_SUCCESS";
export const GET_BARESTHO_FEEDBACKS_ERROR = "GET_BARESTHO_FEEDBACKS_ERROR";

// export const getBaresthoFeedbacks = (page = 1, filters={}) => {
//     return dispatch => {
//         dispatch(sendAction(GET_BARESTHO_FEEDBACKS_REQUEST));
//         axios.get(`${apis.BARESTHO_FEEDBACKS_API}?page=${page}&order_by=created_at&reverse=yes${dictToParams(filters, '&')}`, getAxiosTokenConfig())
//             .then(({data}) => {
//                 dispatch(sendAction(GET_BARESTHO_FEEDBACKS_SUCCESS, {data}));
//             })
//             .catch(error => {
//                 dispatch(sendAction(GET_BARESTHO_FEEDBACKS_ERROR, {error}));
//                 notifyError(errors.GET_FEEDBACKS_ERROR);
//             });
//     }
// };

export const BULK_UPDATE_BARESTHO_FEEDBACKS_REQUEST = "BULK_UPDATE_BARESTHO_FEEDBACKS_REQUEST";
export const BULK_UPDATE_BARESTHO_FEEDBACKS_SUCCESS = "BULK_UPDATE_BARESTHO_FEEDBACKS_SUCCESS";
export const BULK_UPDATE_BARESTHO_FEEDBACKS_ERROR = "BULK_UPDATE_BARESTHO_FEEDBACKS_ERROR";

export const bulkUpdateBaresthoFeedbacks = (data) => {
    return dispatch => {
        dispatch(sendAction(BULK_UPDATE_BARESTHO_FEEDBACKS_REQUEST));
        axios.patch(`${apis.BARESTHO_FEEDBACKS_API}bulk/`, data, getAxiosTokenConfig())
            .then(() => {
                dispatch(getNewFeedbacksMeta());
                dispatch(sendAction(BULK_UPDATE_BARESTHO_FEEDBACKS_SUCCESS, {data}));
            })
            .catch(error => {
                dispatch(sendAction(BULK_UPDATE_BARESTHO_FEEDBACKS_ERROR, {error}));
                notifyError(errors.UPDATE_FEEDBACKS_ERROR);
            });
    }
};

// GET BARESTHO FEEDBACKS STATS
export const GET_BARESTHO_FEEDBACKS_STATS_REQUEST = "GET_BARESTHO_FEEDBACKS_STATS_REQUEST";
export const GET_BARESTHO_FEEDBACKS_STATS_SUCCESS = "GET_BARESTHO_FEEDBACKS_STATS_SUCCESS";
export const GET_BARESTHO_FEEDBACKS_STATS_ERROR = "GET_BARESTHO_FEEDBACKS_STATS_ERROR";

export const getBaresthoFeedbacksStats = () => {
    return dispatch => {
        dispatch(sendAction(GET_BARESTHO_FEEDBACKS_REQUEST));
        axios.get(apis.BARESTHO_FEEDBACKS_STATS_API, getAxiosTokenConfig())
            .then(({data}) => {
                dispatch(sendAction(GET_BARESTHO_FEEDBACKS_STATS_SUCCESS, {data}));
            })
            .catch(error => {
                dispatch(sendAction(GET_BARESTHO_FEEDBACKS_STATS_ERROR, {error}));
                notifyError(errors.GET_FEEDBACKS_STATS_ERROR);
            });
    }
};

// GET SURVEYS
export const GET_SURVEYS_REQUEST = "GET_SURVEYS_REQUEST";
export const GET_SURVEYS_SUCCESS = "GET_SURVEYS_SUCCESS";
export const GET_SURVEYS_ERROR = "GET_SURVEYS_ERROR";

export const getSurveys = () => {
    return dispatch => {
        dispatch(sendAction(GET_SURVEYS_REQUEST));
        axios.get(apis.SURVEYS_API, getAxiosTokenConfig())
            .then(({data}) => {
                dispatch(sendAction(GET_SURVEYS_SUCCESS, {data}));
            })
            .catch(error => {
                dispatch(sendAction(GET_SURVEYS_ERROR, {error}));
                notifyError(errors.GET_SURVEYS_ERROR);
            });
    }
};

// GET SURVEYS
export const GET_NEW_FEEDBACKS_REQUEST = "GET_NEW_FEEDBACKS_REQUEST";
export const GET_NEW_FEEDBACKS_SUCCESS = "GET_NEW_FEEDBACKS_SUCCESS";
export const GET_NEW_FEEDBACKS_ERROR = "GET_NEW_FEEDBACKS_ERROR";

export const getNewFeedbacksMeta = () => {
    return dispatch => {
        dispatch(sendAction(GET_NEW_FEEDBACKS_REQUEST));
        axios.get(apis.GET_NEW_FEEDBACKS_API, getAxiosTokenConfig())
            .then(({data}) => {
                dispatch(sendAction(GET_NEW_FEEDBACKS_SUCCESS, {data}));
            })
            .catch(error => {
                dispatch(sendAction(GET_NEW_FEEDBACKS_ERROR, {error}));
                notifyError(errors.GET_NEW_FEEDBACKS_ERROR);
            });
    }
};


// WEBPACK FOOTER //
// ./src/store/actions/feedbacks.js